import request from '@/utils/request'

export function updateShareBaseCfg(data) {
  return request({
    url: 'api/v1/share-base/updateBaseCfg',
    method: 'post',
    data: data
  })
}

export function getShareBaseCfgList(data) {
  return request({
    url: 'api/v1/share-base/getBaseCfg',
    method: 'post',
    data: data
  })
}

export function delShareBaseCfg(data) {
  return request({
    url: 'api/v1/share-base/delBaseCfg',
    method: 'delete',
    data: data
  })
}

